const formStepTransition = () => {
  const form = document.querySelector('.form');
  const body = document.body;
  
  if (!form || !body) return;

  const formContent = form.querySelector('.form__content');
  const firstStep = form.querySelector('.form__firstStep');
  const secondStep = form.querySelector('.form__secondStep');
  const thirdStep = form.querySelector('.form__thirdStep');
  const nextButton = form.querySelector('.form__next');
  const emailInput = form.querySelector('#fromEmail'); // Changed from #formEmail
  const zipInput = form.querySelector('#formZip');
  const openModalBtns = document.querySelectorAll('.js-openModalForm');
  const closeModalBtn = form.querySelector('.form__close');
  const formElement = form.querySelector('form');
  const submitButton = form.querySelector('input[type="submit"]');

  if (!firstStep || !secondStep || !thirdStep || !nextButton || !emailInput || !zipInput || !formElement) return;

  let isSubmitting = false;

  // Hide second and third steps initially
  secondStep.style.display = 'none';
  thirdStep.style.display = 'none';

  const validateFirstStep = () => {
    const emailValid = emailInput.value.trim() !== '' && emailInput.checkValidity();
    const zipValid = zipInput.value.trim() !== '' && zipInput.checkValidity();
    
    emailInput.classList.toggle('input-error', !emailValid);
    zipInput.classList.toggle('input-error', !zipValid);
    
    if (!emailValid) emailInput.focus();
    else if (!zipValid) zipInput.focus();
    
    return emailValid && zipValid;
  };

  const goToSecondStep = () => {
    firstStep.style.display = 'none';
    if (formContent) formContent.style.display = 'none';
    secondStep.style.display = 'block';
  };

  const goToThirdStep = () => {
    firstStep.style.display = 'none';
    secondStep.style.display = 'none';
    thirdStep.style.display = 'block';
    form.classList.add('sent');
  };

  const openModal = () => {
    form.classList.add('is-shown');
    body.classList.add('is-hidden');
  };

  const closeModal = () => {
    form.classList.remove('is-shown');
    body.classList.remove('is-hidden');
    
    // Reset form when closing
    setTimeout(() => {
      formElement.reset();
      firstStep.style.display = 'block';
      secondStep.style.display = 'none';
      thirdStep.style.display = 'none';
      if (formContent) formContent.style.display = 'block';
      form.classList.remove('sent');
      isSubmitting = false;
    }, 300);
  };

  // Next button handler
  nextButton.addEventListener('click', (e) => {
    e.preventDefault();
    if (validateFirstStep()) goToSecondStep();
  });

  // Form submit handler
  formElement.addEventListener('submit', (e) => {
    e.preventDefault();
    
    // If on first step, validate and go to second step
    if (firstStep.style.display !== 'none') {
      if (validateFirstStep()) goToSecondStep();
      return;
    }
    
    // If on second step, submit form
    if (secondStep.style.display !== 'none') {
      if (isSubmitting) return;
      isSubmitting = true;
      
      // Disable submit button
      if (submitButton) {
        submitButton.disabled = true;
        submitButton.value = 'Sending...';
      }
      
      const formData = new FormData(formElement);
      
      fetch(formElement.getAttribute('action') || window.location.href, {
  method: 'POST',
  body: formData,
  headers: {
    'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json'
  }
})
.then(response => {
  console.log('Response status:', response.status);
  return response.text().then(text => {
    console.log('Response body:', text);
    if (!response.ok && response.status !== 302) {
      throw new Error('Server error: ' + response.status);
    }
    try {
      return JSON.parse(text);
    } catch {
      return {};
    }
  });
})
.then(() => {
  goToThirdStep();
})
.catch(error => {
  console.error('Error:', error);
  alert('An error occurred while submitting the form. Please try again.');
  isSubmitting = false;
  if (submitButton) {
    submitButton.disabled = false;
    submitButton.value = 'Send';
  }
});
    }
  });

  // Open modal buttons
  openModalBtns.forEach((btn) => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      openModal();
    });
  });

  // Close modal button
  if (closeModalBtn) {
    closeModalBtn.addEventListener('click', (e) => {
      e.preventDefault();
      closeModal();
    });
  }

  // Close modal on background click
  form.addEventListener('click', (e) => {
    if (e.target === form) {
      closeModal();
    }
  });
};

export default formStepTransition;